// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__KC_YJ","amount":"Amount_amount__2CVbh","tip":"Amount_tip__3O3-N","tipHeader":"Amount_tipHeader__1xGKf","tipsWrap":"Amount_tipsWrap__3p2eJ"};